import { render, staticRenderFns } from "./RecentOrderSheet.vue?vue&type=template&id=2bb2c257&"
import script from "./RecentOrderSheet.vue?vue&type=script&lang=js&"
export * from "./RecentOrderSheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports